import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import { Box, ButtonStyled, SpanStyled } from "./components/styled/Elements";
import i18n from "./languages/INEXT";
import { createRoot } from "react-dom/client";

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const urlRegex =
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

export const getAccessToken = () => {
  const storedToken =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");
  const accessToken = JSON.parse(storedToken);
  return accessToken;
};

/** Safe in-app path for login `?next=` (blocks protocol-relative URLs). */
export const safeInternalPath = (path) => {
  if (typeof path !== "string") {
    return "";
  }
  const trimmed = path.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return "";
  }
  return trimmed;
};

/**
 * Redirect to login with `?next=` when the user is not authenticated.
 * @returns {boolean} true if already authenticated (caller may proceed).
 */
export const requireAuthNavigate = (navigate, isAuthenticated, nextPath) => {
  if (isAuthenticated) {
    return true;
  }
  const next = safeInternalPath(nextPath) || "/";
  navigate(`/login?next=${encodeURIComponent(next)}`);
  return false;
};

/** Read a File as raw base64 (no data-URL prefix) for JSON register payloads. */
export const fileToBase64Payload = (file) =>
  new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve({
        base64: comma >= 0 ? result.slice(comma + 1) : result,
        filename: file.name || "upload.bin",
      });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const reqFormatDate = (isoDate) => {
  const date = new Date(isoDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${year}-${month}-${day}`;
};
export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getFormattedTime = (isoDate) => {
  const date = new Date(isoDate);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${ampm}`;
};

export const formateAmounts = (num) => {
  var parsedNum = parseFloat(num);
  var formattedNum = parsedNum.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNum ? formattedNum : 0;
};
export const formatAmount = (num) => {
  var parsedNum = parseFloat(num);
  var formattedNum = parsedNum.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return formattedNum ? formattedNum : 0;
};
export const formatAmountForDisplay = (value) => {
  const strValue = value.toString();

  // If it ends with a decimal point, preserve it
  if (strValue.endsWith(".")) {
    const wholePart = strValue.slice(0, -1);
    if (wholePart === "") return ".";
    return formatAmount(wholePart) + ".";
  }

  // If it's just a decimal point
  if (strValue === ".") {
    return ".";
  }

  // Otherwise, use normal formatting
  return formatAmount(value);
};

export const countWords = (value) => {
  const normalized = value
    .trim()
    .replace(/\n/g, " ")
    .replace(/\u200f|\u200e/g, "");

  const words = normalized.split(/\s+/).filter((word) => word.length > 0);

  return words.length;
};

// export const getVideoThumbnail = (file) => {
//   return new Promise((resolve) => {
//     const url = URL.createObjectURL(file);
//     const video = document.createElement("video");

//     video.src = url;
//     video.crossOrigin = "anonymous";
//     video.preload = "metadata";
//     video.muted = true;
//     video.playsInline = true;
//     video.currentTime = 0.1;

//     video.onloadeddata = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = 120;
//       canvas.height = 100;
//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//       const imageDataURL = canvas.toDataURL("image/png");

//       URL.revokeObjectURL(url);
//       resolve(imageDataURL);
//     };
//   });
// };

// export const getVideoThumbnail = (input) => {
//   return new Promise((resolve, reject) => {
//     let url;

//     // If input is a File, create object URL
//     if (input instanceof File) {
//       url = URL.createObjectURL(input);
//     } else if (typeof input === "string") {
//       url = input;
//     } else {
//       reject(new Error("Invalid input type. Must be File or string URL."));
//       return;
//     }

//     const video = document.createElement("video");
//     video.src = url;
//     video.muted = true;
//     video.playsInline = true;
//     video.preload = "metadata";

//     // Set crossOrigin BEFORE setting src for external URLs
//     if (typeof input === "string") {
//       video.crossOrigin = "anonymous";
//     }

//     let hasLoaded = false;

//     const cleanup = () => {
//       if (input instanceof File) {
//         URL.revokeObjectURL(url);
//       }
//     };

//     const generateThumbnail = () => {
//       if (hasLoaded) return; // Prevent multiple executions
//       hasLoaded = true;

//       try {
//         const canvas = document.createElement("canvas");
//         canvas.width = 120;
//         canvas.height = 100;

//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//         const imageDataURL = canvas.toDataURL("image/png");

//         cleanup();
//         resolve(imageDataURL);
//       } catch (err) {
//         cleanup();
//         reject(new Error("Failed to generate thumbnail: " + err.message));
//       }
//     };

//     // Multiple event listeners for better compatibility
//     video.onloadeddata = () => {
//       // Try to seek to a frame shortly after start
//       video.currentTime = 0.1;
//     };

//     video.onseeked = generateThumbnail;

//     // Fallback if seeking doesn't work
//     video.oncanplay = () => {
//       if (!hasLoaded) {
//         setTimeout(generateThumbnail, 100);
//       }
//     };

//     video.onerror = (err) => {
//       cleanup();
//       reject(new Error("Failed to load video for thumbnail generation. Check CORS settings or URL accessibility."));
//     };
//   });
// };
export const getVideoThumbnail = (input) => {
  return new Promise((resolve, reject) => {
    let url;

    if (input instanceof File) {
      url = URL.createObjectURL(input);
    } else if (typeof input === "string") {
      url = input;
    } else {
      reject(new Error("Invalid input type. Must be File or string URL."));
      return;
    }

    const video = document.createElement("video");
    video.src = url;
    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";
    video.crossOrigin = "anonymous"; // Always set this for consistency

    const cleanup = () => {
      if (input instanceof File) {
        URL.revokeObjectURL(url);
      }
    };

    const tryGenerate = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = 120;
        canvas.height = 100;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataURL = canvas.toDataURL("image/png");
        cleanup();
        resolve(imageDataURL);
      } catch (err) {
        cleanup();
        reject(err);
      }
    };

    video.onloadeddata = () => {
      video.currentTime = 0.1;
    };

    video.onseeked = tryGenerate;

    video.onerror = () => {
      cleanup();
      reject(new Error("Video load error or CORS issue"));
    };

    video.oncanplay = () => {
      setTimeout(tryGenerate, 100); // fallback
    };
  });
};

export const getVideoSrc = (input) => {
  if (input instanceof File) {
    return URL.createObjectURL(input);
  }
  if (typeof input === "string") {
    return input;
  }
  return null;
};

export const showSessionExpiredModal = () => {
  const modalContainer = document.createElement("div");
  document.body.appendChild(modalContainer);

  const handleSessionReset = () => {
    modalContainer.remove(); // Remove modal from DOM on close
    window.location.href = "/login";
  };

  const modalJSX = (
    <Modal show={true} centered size="sm">
      <Modal.Body className="text-center px-4 pt-4 pb-2">
        <SpanStyled color="var(--text)">
          {i18n.t("session_expired_login_again")}
        </SpanStyled>
        <Box className="d-flex justify-content-center mt-3">
          <ButtonStyled
            label={i18n.t("ok")}
            bg={"var(--white)"}
            color={"var(--themeColor)"}
            onClick={handleSessionReset}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );

  const root = createRoot(modalContainer);
  root.render(modalJSX); // Correct rendering method for React 18
};

export function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // prevent CORS issues
    image.src = url;
  });
}

export default async function getCroppedImg(imageSrc, crop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, "image/jpeg");
  });
}

export const isArabic = (text) => {
  const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  return arabicRegex.test(text);
};

export const formatNumber = (num) => {
  if (num >= 1_000_000)
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return num;
};
